import { render, staticRenderFns } from "./dashboard_stuff.vue?vue&type=template&id=fb9e7dbc&scoped=true&"
import script from "./dashboard_stuff.vue?vue&type=script&lang=js&"
export * from "./dashboard_stuff.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_stuff.vue?vue&type=style&index=0&id=fb9e7dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9e7dbc",
  null
  
)

export default component.exports